export type GarageAction = 'resume' | 'submit' | 'tour' | 'event';

/**
 * Serialises garage launches so a superseded async response cannot mount a
 * stale race or unlock controls still owned by a newer action.
 */
export class GarageActionController {
  private generation = 0;
  private currentAction: GarageAction | null = null;

  constructor(private readonly onLockChange: (locked: boolean) => void) {}

  get pending(): GarageAction | null {
    return this.currentAction;
  }

  begin(action: GarageAction): number {
    const token = ++this.generation;
    this.currentAction = action;
    this.onLockChange(true);
    return token;
  }

  isCurrent(token: number): boolean {
    return token === this.generation && this.currentAction !== null;
  }

  finish(token: number): boolean {
    if (!this.isCurrent(token)) return false;
    this.currentAction = null;
    this.onLockChange(false);
    return true;
  }

  cancel(): void {
    this.invalidate();
    this.onLockChange(false);
  }

  /** Invalidates late completions while the owning view is being replaced. */
  invalidate(): void {
    this.generation += 1;
    this.currentAction = null;
  }
}
